module.exports = __webpack_public_path__ + "static/img/6716_phase_function_Paper_PointsHejduk_Prediction.f1da077.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6716_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 5mXr
// module chunks = 0